import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as quotesActions from '../actions/quotes.actions';
import { produceOn } from '../../../../../reducers/immer.helper';
export interface QuoteState {
  quotesData?: any[];
  currentData?: any;
  result?: any;
  isLoading?: boolean;
  actionInProgress?: boolean;
  actionSuccessful?: boolean;
}
export const initialState: QuoteState = {
  quotesData: [],
  currentData: {},
  result: '',
  isLoading: false,
  actionInProgress: false,
  actionSuccessful: true,
};

const quoteReducer = createReducer(
  initialState,
  produceOn(quotesActions.getQuote, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),
  produceOn(quotesActions.getQuoteSuccess, (draft, result) => {
    draft.quotesData = result.data;
    draft.isLoading = false;
    draft.currentData = {};
  }),
  produceOn(quotesActions.getQuoteFailure, (draft, result) => {
    draft.isLoading = false;
  }),
  //create user
  produceOn(quotesActions.rejectQuote, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(quotesActions.rejectQuoteSuccess, (draft, result) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = result.data;
  }),
  produceOn(quotesActions.rejectQuoteFailure, (draft, result) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  //delete user
  produceOn(quotesActions.acceptQuote, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(quotesActions.acceptQuoteSuccess, (draft) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),
  produceOn(quotesActions.acceptQuoteFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),
  produceOn(quotesActions.clearState, (draft: any) => {
    Object.keys(draft).forEach((key) => {
      delete draft[key];
    });
    Object.assign(draft, initialState);
  }),

  // compare

  produceOn(quotesActions.compareQuotes, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(quotesActions.compareQuotesSuccess, (draft, { data }) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = data; // Store the API response data in the state
  }),
  produceOn(quotesActions.compareQuotesFailure, (draft, { error }) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = false;
    console.error('Error in compareQuotesFailure:', error);
  }),


    // Handle the lead compare quotes action
    produceOn(quotesActions.leadCompareQuotes, (draft) => {
      draft.isLoading = true;
      draft.actionInProgress = true;
      draft.actionSuccessful = false;
      draft.error = null; // Reset error on new action
    }),
  
    produceOn(quotesActions.leadCompareQuotesSuccess, (draft, { data }) => {
      draft.isLoading = false;
      draft.actionInProgress = false;
      draft.actionSuccessful = true;
      draft.currentData = data; // Store the API response data in the state
      draft.error = null; // Reset error on success
    }),
  
    produceOn(quotesActions.leadCompareQuotesFailure, (draft, { error }) => {
      draft.isLoading = false;
      draft.actionInProgress = false;
      draft.actionSuccessful = false;
      draft.error = error; // Store error in state
      console.error('Error in leadCompareQuotesFailure:', error);
    })








);

export function reducer(state: QuoteState | undefined, action: Action): any {
  return quoteReducer(state, action);
}
